import { render, staticRenderFns } from "./SidebarAddNewAffiliate.vue?vue&type=template&id=4829722e&"
import script from "./SidebarAddNewAffiliate.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewAffiliate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports